export default __webpack_public_path__ + "static/media/img_2.0b9e8040.jpeg";